<template>
  <div>
    <v-data-table :items="getStaffAccount" class="elevation" :headers="headers">
      <template slot="items" slot-scope="props">
        <!-- <td>{{ props.item[".key"] }}</td> -->
        <td>{{ props.item.staffName }}</td>
        <td>{{ props.item.staffRole }}</td>
        <td>{{ firmbyId(props.item.firm) }}</td>
        <td>{{ props.item.creditTotal | amount }}</td>
        <td>{{ props.item.debitTotal | amount }}</td>
        <td>{{ (props.item.creditTotal - props.item.debitTotal) | amount }}</td>

        <td>
          <v-btn
            class="primary white--text"
            @click="openSalaryDialog(props.item)"
          >
            View
          </v-btn>
        </td>
      </template>
      <template slot="no-data"> No Staff to Show </template>
    </v-data-table>

    <v-dialog v-model="dialog" transition="dialog-bottom-transition">
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ selectedStaffName }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click.native="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :items="selectedSalaryList"
        class="elevation"
        :headers="salaryListHeaders"
      >
        <template slot="items" slot-scope="props">
          <!-- <td>{{ props.item.isOpening ? "" : props.item[".key"] }}</td> -->
          <td>{{ props.item.isOpening ? "" : new Date(props.item.date).toLocaleDateString("en-GB") }}</td>
          <td>{{ props.item.isOpening ? "" : getFirmName(props.item.firm) }}</td>
          <td>{{ props.item.transactionType }}</td>

          <template v-if="props.item.isCredited">
            <td>
              <h3 class="success--text text--darken-4">
                {{ props.item.amount | amount }}
              </h3>
            </td>
            <td></td>
          </template>

          <template v-if="!props.item.isCredited">
            <td></td>
            <td>
              <h3 class="error--text text--darken-4">
                {{ props.item.amount | amount }}
              </h3>
            </td>
          </template>
          <td>{{props.item.isOpening ? "" : props.item.paymentType }}</td>
          <td>
            <v-btn
              icon
              class="primary--text"
              v-if="props.item.invoiceIdCash || props.item.invoiceIdBank"
              @click="openAssetInvoiceEdit(props.item)"
            >
              <v-icon dark> edit </v-icon>
            </v-btn>
          </td>
          <td>
            <v-btn
              icon
              class="primary--text"
              v-if="props.item.invoiceIdCash || props.item.invoiceIdBank"
              @click="deleteSalary(props.item)"
            >
              <v-icon dark> delete </v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="no-data"> no record found </template>
      </v-data-table>
    </v-dialog>
    <!-- End of Edit Asset -->

    <!-- Start of Asset Invoice Edit -->
    <v-dialog
      v-model="dialogEditInvoice"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-toolbar card dark color="primary">
        <v-toolbar-title>Edit Salary</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click.native="dialogEditInvoice = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card tile>
        <v-card-text>
          <v-menu
            :close-on-content-click="false"
            v-model="assetdatepicker"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="salaryInvoiceDate"
              label="Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker
              v-model="salaryInvoiceDate"
              @input="assetdatepicker = false"
            />
          </v-menu>
          <v-select
            v-model="selectedFirmFromAsset"
            :items="firmsByBrand"
            label="Select Firm"
            required
          >
            <template slot="selection" slot-scope="data">
              {{ data.item.text }}
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title
                  v-html="
                    `${data.item.firm.name}${
                      data.item.firm.proprietor
                        ? ' | ' + data.item.firm.proprietor
                        : ''
                    } | ₹: ${(data.item.firm.amount || 0).toLocaleString()}`
                  "
                />
              </v-list-tile-content>
            </template>
          </v-select>
          <v-select
            :items="staffByBrand"
            v-model="selectStaff"
            label="Select Staff Account"
          >
          </v-select>

          <!-- Addition or deletion on asset if old -->
          <v-select
            v-if="selectedFirmFromAsset && selectStaff"
            v-model="addition"
            label="Select transaction type"
            :items="getTransactionTypeOptions"
          />
          <v-text-field
            v-if="selectedFirmFromAsset && selectStaff && addition"
            type="number"
            label="Amount"
            v-model="additionAmount"
          />

          <!-- asset payement type -->
          <v-select
            dense
            v-if="additionAmount"
            label="Select Transaction Payment Type"
            v-model="operationPaymentType"
            :items="paymentOptions"
          />
          <!-- if cash&bank: ask for both value for seperate deduction -->
          <v-text-field
            v-if="operationPaymentType === 'CashAndBank Account'"
            v-model="operationAmountFromCash"
            type="number"
            label="Transactionn Amount to Pay From Cash"
            :error-messages="
              Number(operationAmountFromCash) +
                Number(operationAmountFromBank) !=
                Number(additionAmount) &&
              operationPaymentType == 'CashAndBank Account'
                ? [
                    'Sum of Cash amount and bank amount should be equal to Asset Amount',
                  ]
                : []
            "
          />
          <v-text-field
            v-if="operationPaymentType === 'CashAndBank Account'"
            v-model="operationAmountFromBank"
            type="number"
            label="Transactionn Amount to Pay From Bank"
            :error-messages="
              Number(operationAmountFromCash) +
                Number(operationAmountFromBank) !=
                Number(additionAmount) &&
              operationPaymentType == 'CashAndBank Account'
                ? [
                    'Sum of Cash amount and bank amount should be equal to Asset Amount',
                  ]
                : []
            "
          />
          <v-select
            v-if="operationPaymentType && operationPaymentType !== 'Cash'"
            v-model="operationAccountForTransaction"
            :items="otherAccountByBrand"
            label="Bank Account to Pay operation amount from Bank"
            required
          >
            <template slot="selection" slot-scope="data">
              {{ data.item.text }}
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title
                  v-html="
                    `${data.item.text}
                            ${
                              data.item.account.bankName
                                ? ' | ' + data.item.account.bankName
                                : ''
                            }
                            ${
                              data.item.account.accountType
                                ? ' | ' + data.item.account.accountType
                                : ''
                            }
                            | ₹: ${(
                              data.item.account.amount || 0
                            ).toLocaleString()}`
                  "
                />
              </v-list-tile-content>
            </template>
          </v-select>

          <!-- add asset remark for  invoice/asset add-->
          <v-text-field
            v-if="additionAmount && operationPaymentType"
            label="Remark"
            v-model="staffRemark"
          >
          </v-text-field>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="salaryAmountClick">
              <v-icon right dark>money_off</v-icon>Save
            </v-btn>
            <v-btn color="primary" @click="dialogEditInvoice = false">
              <v-icon left dark>cancel</v-icon>Cancel
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import _ from "lodash";

const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];

export default {
  name: "SalaryTableInfo",
  props: {
    accountsByBrand: { type: Array },
    firmsByBrand: { type: Array },
    staffAccount: { type: Array },
    paymentOptions: { type: Array },
  },
  created() {
    this.$bindAsArray(
      "salarys",
      this.$root.$firebaseRefs.salarys
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "firms",
      this.$root.$firebaseRefs.firm
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "staff",
      this.$root.$firebaseRefs.staff
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsObject(
      "firmById",
      this.$root.$firebaseRefs.firm
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsObject(
      "bankById",
      this.$root.$firebaseRefs.account
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsObject(
      "staffById",
      this.$root.$firebaseRefs.staff
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),
    getStaffAccount() {
      if (this.selectedBrand) {
        const staffList = this.staff.filter(
          (item) => item["brand"] === this.selectedBrand && item["firm"] != ""
        );

        const result = staffList.map((e) => {
          const salaryList = _.filter(
            this.salarys,
            { staffId: e[".key"] },
            e.date >= this.finYear.start,
            e.date <= this.finYear.end
          );
          e.salaryList = salaryList;
          const debitTotal = _.sumBy(salaryList, function (s) {
            if (!s.isCredited) return s.amount;
          });

          e.debitTotal = debitTotal ? debitTotal : 0;

          let creditTotal = _.sumBy(salaryList, function (s) {
            if (s.isCredited) return s.amount;
          });
          if(e.openingBalance) {
            creditTotal += Number.parseFloat(e.openingBalance);
            e.salaryList.push({
              "isCredited" : true,
              amount : e.openingBalance,
              isOpening : true,
              transactionType : "Opening Balance"
            })
          }
          
          e.creditTotal = creditTotal ? creditTotal : 0;
          return e;
        });

        return result;
      }
    },
    accountsByFirm() {
      if (this.selectedFirmFromAsset) {
        return this.accountsByBrand.filter(
          (item) => item.account.firm === this.selectedFirmFromAsset
        );
      }
      return [];
    },
    staffByBrand() {
      if (this.selectedFirmFromAsset) {
        return this.staffAccount.filter(
          (item) => item.staff.firm === this.selectedFirmFromAsset
        );
      }
      return [];
    },
    otherAccountByBrand() {
      return this.accountsByFirm.filter(
        (account) => account.account.accountType !== "Loan A/C"
      );
    },
    getTransactionTypeOptions() {
      return [
        { text: "Salary", value: "salary" },
        { text: "Advance", value: "advance" },
        { text: "Commission", value: "commission" },
        { text: "Return", value: "return" },
      ];
    },
  },
  data() {
    return {
      dialog: false,
      selectedSalaryList: [],
      selectedStaffName: "",
      asset: {},
      selectedAsset: [],
      selectedSalary: null,
      selectedCashInvoice: null,
      selectedBankInvoice: null,
      selectStaff: null,
      dialogEditInvoice: false,
      additionAmount: null,
      operationPaymentType: null,
      operationAmountFromCash: 0,
      operationAmountFromBank: 0,
      selectedFirmFromAsset: null,
      operationAccountForTransaction: null,
      staffRemark: null,
      addition: null,
      selectStaff: null,
      salaryInvoiceDate: null,
      assetdatepicker: false,
      headers: [
        // { text: "Id", value: ".key", sortable: false },
        { text: "Name", value: "staffName", sortable: false },
        { text: "Role", value: "staffRole", sortable: false },
        { text: "Firm", value: "firm", sortable: false },
        { text: "Debit", value: "amount", sortable: false },
        { text: "Credit", value: "amount", sortable: false },
        { text: "Running Balance", value: "amount", sortable: false },
        { text: "Action", value: "paymentType", sortable: false },
      ],
      salaryListHeaders: [
        // { text: "Id", value: ".key", sortable: false },
        { text: "Date", value: "date", sortable: true },
        { text: "Firm", value: "firm", sortable: true },
        { text: "Transaction type", value: "transactionType", sortable: false },
        { text: "Debit", value: "amount", sortable: false },
        { text: "Credit", value: "amount", sortable: false },
        { text: "Payment Type", value: "paymentType", sortable: false },
        { text: "Action", value: "paymentType", sortable: false },
      ],
    };
  },
  methods: {
    openSalaryDialog(payload) {
      this.selectedSalaryList = payload.salaryList;
      this.selectedStaffName = payload.staffName + " |" + payload.staffRole;
      this.dialog = true;
    },
    firmbyId(id) {
      return this.firms.filter((item) => item[".key"] == id)[0].name;
    },
    getFirmName(e) {
      let firm;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter((item) => item[".key"] === e)[0];
      }
      if (firm) return firm.name;
    },
    deleteSalary(salary) {
      if (confirm("Are you sure?")) {
        this.$root.$firebaseRefs.salarys.child(salary[".key"]).remove();
        this.$root.$firebaseRefs.invoice.child(salary.invoiceIdCash).remove();
        this.$root.$firebaseRefs.invoice.child(salary.invoiceIdBank).remove();
        this.dialogEditInvoice = false;
      }
    },
    openAssetInvoiceEdit(salary) {
      this.selectedSalary = salary;
      this.selectedCashInvoice = salary.invoiceIdCash;
      this.selectedBankInvoice = salary.invoiceIdBank;
      this.additionAmount = Number.parseFloat(salary.amount);
      this.operationAmountFromCash = Number.parseFloat(
        salary.amountFromCash || 0
      );
      this.operationAmountFromBank = Number.parseFloat(
        salary.amountFromBank || 0
      );
      this.operationAccountForTransaction = salary.bank;
      let today = new Date(salary.date);
      this.salaryInvoiceDate = `${today.getFullYear()}-${
        today.getMonth() + 1
      }-${today.getDate()}`;
      this.selectedFirmFromAsset = salary.firm;
      this.selectStaff = salary.staffId;
      this.addition = salary.transactionType;
      this.additionAmount = Number.parseFloat(salary.amount || 0);
      this.operationPaymentType = salary.paymentType;
      this.staffRemark = salary.remark;

      this.dialogEditInvoice = true;
    },

    salaryAmountClick: async function (e) {

         let additionAmount =
        Number.parseFloat(this.additionAmount) -
        Number.parseFloat(this.selectedSalary.amount);
        let operationAmountFromCash = Number.parseFloat(this.operationAmountFromCash) -
          Number.parseFloat(this.selectedSalary.amountFromCash);
        let operationAmountFromBank = Number.parseFloat(this.operationAmountFromBank) -
          Number.parseFloat(this.selectedSalary.amountFromBank);
      var self = this;

      const asset = {
        brand: this.selectedBrand,
      };

      if (!this.selectedFirmFromAsset) {
        return this.$emit("notify", "select firm");
      }

      if (!this.addition) {
        return this.$emit("notify", "Select transaction type");
      }

      if (!this.additionAmount) {
        return this.$emit("notify", "Add amount");
      } else {
        asset.totalAdditionAmount =
          (this.asset.totalAdditionAmount || 0) + Number(this.additionAmount);
      }

      if (
        this.operationPaymentType === "CashAndBank Account" &&
        (!this.operationAmountFromCash || !this.operationAmountFromBank)
      ) {
        return this.$emit(
          "notify",
          "Enter amount to pay from bank and cash for operation"
        );
      }
      if (
        this.operationPaymentType !== "Cash" &&
        !this.operationAccountForTransaction
      ) {
        return this.$emit("notify", "Select Bank account for operation");
      }

      let transactionError = false;
      if (this.addition != "return") {
        const firmBalance = this.firmById[this.selectedFirmFromAsset].amount;
        const accountBalance = this.operationAccountForTransaction
          ? this.bankById[this.operationAccountForTransaction].amount
          : 0;
         
        switch (this.operationPaymentType) {
          case "Cash":
              
            if (additionAmount > firmBalance) {
              transactionError = `Insufficiant balance in firm ${firmBalance}`;
              break;
            }
            break;
          case "Bank Account":
            if (additionAmount > accountBalance) {
              // Insufficient balance in bank account
              transactionError = `Insufficient balance in bank Account ${accountBalance} to pay`;
              break;
            }
            break;
          case "CashAndBank Account":
            if (
              Number(additionAmount) !==
              Number(operationAmountFromCash) +
                Number(operationAmountFromBank)
            ) {
              transactionError =
                "Total of by cash and bank amount should be same as operation Amount!";
              break;
            }
            if (operationAmountFromCash > firmBalance) {
              transactionError = `Insufficiant balance in firm ${firmBalance}`;
              break;
            }
            if (operationAmountFromBank > accountBalance) {
              // Insufficient balance in bank account
              transactionError = `Insufficient balance in bank Account ${accountBalance} to pay`;
              break;
            }
            break;
        }
      }
      if (transactionError) {
        return this.$emit("notify", transactionError);
      }

      // salary adance commostion debite
      let globStaffType = this.staffById[this.selectStaff].staffRole;

      let salaryData = {
        brand: this.selectedBrand,
        firm: this.selectedFirmFromAsset,
        staffId: this.selectStaff,
        staffType: globStaffType,
        transactionType: this.addition, //salary etc
        paymentType: this.operationPaymentType,
        amount: Number(this.additionAmount),
        date: this.salaryInvoiceDate
          ? Date.parse(this.salaryInvoiceDate)
          : Date.now(),
        remark: this.staffRemark,
      };

      if (this.addition != "return") {
        salaryData.isCredited = true;

        // create a invoice data now
        if (this.operationPaymentType == "Cash") {
          const invoiceCashData = {
            brand: this.selectedBrand,
            firm: this.selectedFirmFromAsset,
            type: "automatic invoice",
            transactionType: "Staff",
            paymentType: this.operationPaymentType,
            accountNumber: "",
            isCredited: false,
            totalAmount: Number(this.additionAmount),
            remark: this.staffRemark,
            staffkey: this.selectStaff,
            staffType: globStaffType,
            date: this.salaryInvoiceDate
              ? Date.parse(this.salaryInvoiceDate)
              : Date.now(),
          };

          var firm = this.firmById[invoiceCashData.firm];
          firm.amount = firm && firm.amount - additionAmount;
          this.$root.$firebaseRefs.firm.child(invoiceCashData.firm).set(firm);

          invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
          invoiceCashData.salaryType = this.addition;
          this.$root.$firebaseRefs.invoice
            .child(this.selectedCashInvoice)
            .set(invoiceCashData);
          //let res = self.$root.$firebaseRefs.invoice.push(invoiceCashData);
          salaryData["invoiceIdCash"] = this.selectedCashInvoice;
          salaryData["amountFromCash"] = invoiceCashData["totalAmount"];

          //   this.$root.$firebaseRefs.firm.child(this.selectedFirmFromAsset).once('value').then( function(snap) {
          //       if(Number(snap.val().amount) >= invoiceCashData.totalAmount){
          //           self.$root.$firebaseRefs.firm.child(invoiceCashData.firm).update({
          //                   amount: Number(snap.val().amount) - Number(invoiceCashData.totalAmount)
          //           });

          //           self.snackbarSuccess=true;
          //           self.snackbarSuccessText = "staff amount paid";

          //           invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
          //           self.$root.$firebaseRefs.invoice.push(invoiceCashData);

          //           self.additionAmount = null;
          //           self.selectedFirmFromAsset = null;
          //           self.staffRemark = null;
          //       }else{
          //           return this.$emit('notify', 'Insufficient Balance To Pay');
          //       }
          //   })
        } else if (this.operationPaymentType == "Bank Account") {
          let invoiceViaAccount = {
            brand: this.selectedBrand,
            firm: this.selectedFirmFromAsset,
            type: "automatic invoice",
            transactionType: "Staff",
            paymentType: this.operationPaymentType,
            isCredited: false,
            totalAmount: Number(this.additionAmount),
            remark: this.staffRemark,
            staffkey: this.selectStaff,
            staffType: globStaffType,
            date: this.salaryInvoiceDate
              ? Date.parse(this.salaryInvoiceDate)
              : Date.now(),
          };

          invoiceViaAccount.amountFromBank = additionAmount;
          invoiceViaAccount.bank = this.operationAccountForTransaction;

          if (invoiceViaAccount.bank) {
            invoiceViaAccount.accountNumber =
              this.bankById[invoiceViaAccount.bank].accountnumber;
          }

          var firm = this.firmById[invoiceViaAccount.firm];
          var bank = this.bankById[invoiceViaAccount.bank];

          bank.amount = bank && bank.amount - invoiceViaAccount.totalAmount;
          this.$root.$firebaseRefs.account
            .child(invoiceViaAccount.bank)
            .set(bank);
          invoiceViaAccount.salaryType = this.addition;
          // let res = self.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
          this.$root.$firebaseRefs.invoice
            .child(this.selectedBankInvoice)
            .set(invoiceViaAccount);
          salaryData["invoiceIdBank"] = this.selectedBankInvoice;
          salaryData["amountFromBank"] = invoiceViaAccount["totalAmount"];
          salaryData["bank"] = invoiceViaAccount["bank"];
          self.additionAmount = null;
          self.selectedFirmFromAsset = null;
          self.staffRemark = null;
        } else {
          // CASHwithBank Account

          let invoiceData = {
            brand: this.selectedBrand,
            firm: this.selectedFirmFromAsset,
            type: "automatic invoice",
            transactionType: "Staff",
            isCredited: false,
            remark: this.staffRemark,
            staffkey: this.selectStaff,
            staffType: globStaffType,
            date: this.salaryInvoiceDate
              ? Date.parse(this.salaryInvoiceDate)
              : Date.now(),
          };

          //CASH *************************************
          var firm = this.firmById[invoiceData.firm];

          const invoiceCash = { ...invoiceData };
          invoiceCash.paymentType = "CashAndBank Account";
          invoiceCash.totalAmount = Number(this.operationAmountFromCash);
          invoiceCash.amountFromCash = Number(this.operationAmountFromCash);

          firm.amount = firm && firm.amount - operationAmountFromCash;
          this.$root.$firebaseRefs.firm.child(invoiceCash.firm).set(firm);
          invoiceCash.salaryType = this.addition;
          //let res = self.$root.$firebaseRefs.invoice.push(invoiceCash);
          salaryData["invoiceIdCash"] = this.selectedCashInvoice;
          this.$root.$firebaseRefs.invoice
            .child(this.selectedCashInvoice)
            .set(invoiceCash);
          salaryData["amountFromCash"] = invoiceCash["totalAmount"];
          // BANK **************************************
          const invoiceBank = { ...invoiceData };
          invoiceBank.paymentType = "Bank Account";
          invoiceBank.totalAmount = Number(this.operationAmountFromBank);
          invoiceBank.amountFromBank = Number(this.operationAmountFromBank);
          invoiceBank.bank = this.operationAccountForTransaction;

          if (invoiceBank.bank) {
            invoiceBank.accountNumber =
              this.bankById[invoiceBank.bank].accountnumber;
          }

          var bank = this.bankById[invoiceBank.bank];
          bank.amount = bank && bank.amount - operationAmountFromBank;
          this.$root.$firebaseRefs.account.child(invoiceBank.bank).set(bank);
          invoiceBank.salaryType = this.addition;
          //res = self.$root.$firebaseRefs.invoice.push(invoiceBank);
          salaryData["invoiceIdBank"] = this.selectedBankInvoice;
          this.$root.$firebaseRefs.invoice
            .child(this.selectedBankInvoice)
            .set(invoiceBank);
          salaryData["amountFromBank"] = invoiceBank["totalAmount"];
          salaryData["bank"] = invoiceBank["bank"];
          self.additionAmount = null;
          self.selectedFirmFromAsset = null;
          self.staffRemark = null;
        }
      } else {
        salaryData.isCredited = false;

        if (this.operationPaymentType == "Cash") {
          const invoiceCashData = {
            brand: this.selectedBrand,
            firm: this.selectedFirmFromAsset,
            type: "automatic invoice",
            transactionType: "Staff",
            paymentType: this.operationPaymentType,
            accountNumber: "",
            isCredited: true,
            totalAmount: Number(this.additionAmount),
            remark: this.staffRemark,
            staffkey: this.selectStaff,
            staffType: globStaffType,
            date: this.salaryInvoiceDate
              ? Date.parse(this.salaryInvoiceDate)
              : Date.now(),
          };

          var firm = this.firmById[invoiceCashData.firm];
          firm.amount = firm && firm.amount + additionAmount;
          this.$root.$firebaseRefs.firm.child(invoiceCashData.firm).set(firm);

          invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
          invoiceCashData.salaryType = this.addition;
          //let res = self.$root.$firebaseRefs.invoice.push(invoiceCashData);
          this.$root.$firebaseRefs.invoice
            .child(this.selectedCashInvoice)
            .set(invoiceCashData);
          salaryData["amountFromCash"] = invoiceCashData["totalAmount"];
          salaryData["invoiceIdCash"] = this.selectedCashInvoice;
        } else if (this.operationPaymentType == "Bank Account") {
          let invoiceViaAccount = {
            brand: this.selectedBrand,
            firm: this.selectedFirmFromAsset,
            type: "automatic invoice",
            transactionType: "Staff",
            paymentType: this.operationPaymentType,
            isCredited: true,
            totalAmount: Number(this.additionAmount),
            remark: this.staffRemark,
            staffkey: this.selectStaff,
            staffType: globStaffType,
            date: this.salaryInvoiceDate
              ? Date.parse(this.salaryInvoiceDate)
              : Date.now(),
          };

          invoiceViaAccount.amountFromBank = invoiceViaAccount.totalAmount;
          invoiceViaAccount.bank = this.operationAccountForTransaction;

          if (invoiceViaAccount.bank) {
            invoiceViaAccount.accountNumber =
              this.bankById[invoiceViaAccount.bank].accountnumber;
          }

          var firm = this.firmById[invoiceViaAccount.firm];
          var bank = this.bankById[invoiceViaAccount.bank];

          bank.amount = bank && bank.amount + additionAmount;
          this.$root.$firebaseRefs.account
            .child(invoiceViaAccount.bank)
            .set(bank);
          invoiceViaAccount.salaryType = this.addition;
          //let res = self.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
          salaryData["invoiceIdBank"] = this.selectedBankInvoice;
          this.$root.$firebaseRefs.invoice
            .child(this.selectedBankInvoice)
            .set(invoiceViaAccount);
          salaryData["amountFromBank"] = invoiceViaAccount["totalAmount"];
          salaryData["bank"] = invoiceViaAccount["bank"];
          self.additionAmount = null;
          self.selectedFirmFromAsset = null;
          self.staffRemark = null;
        } else {
          // CASHwithBank Account

          let invoiceData = {
            brand: this.selectedBrand,
            firm: this.selectedFirmFromAsset,
            type: "automatic invoice",
            transactionType: "Staff",
            isCredited: true,
            remark: this.staffRemark,
            staffkey: this.selectStaff,
            staffType: globStaffType,
            date: this.salaryInvoiceDate
              ? Date.parse(this.salaryInvoiceDate)
              : Date.now(),
          };

          //CASH *************************************
          var firm = this.firmById[invoiceData.firm];

          const invoiceCash = { ...invoiceData };
          invoiceCash.paymentType = "CashAndBank Account";
          invoiceCash.totalAmount = Number(this.operationAmountFromCash);
          invoiceCash.amountFromCash = Number(this.operationAmountFromCash);

          firm.amount = firm && firm.amount + operationAmountFromCash;
          this.$root.$firebaseRefs.firm.child(invoiceCash.firm).set(firm);
          invoiceCash.salaryType = this.addition;
          //let res = self.$root.$firebaseRefs.invoice.push(invoiceCash);
          this.$root.$firebaseRefs.invoice
            .child(this.selectedCashInvoice)
            .set(invoiceCash);
          salaryData["amountFromCash"] = invoiceCash["totalAmount"];
          salaryData["invoiceIdCash"] = this.selectedCashInvoice;
          // BANK **************************************
          const invoiceBank = { ...invoiceData };
          invoiceBank.paymentType = "Bank Account";
          invoiceBank.totalAmount = Number(this.operationAmountFromBank);
          invoiceBank.amountFromBank = Number(this.operationAmountFromBank);
          invoiceBank.bank = this.operationAccountForTransaction;

          if (invoiceBank.bank) {
            invoiceBank.accountNumber =
              this.bankById[invoiceBank.bank].accountnumber;
          }

          var bank = this.bankById[invoiceBank.bank];
          bank.amount = bank && bank.amount + operationAmountFromBank;
          this.$root.$firebaseRefs.account.child(invoiceBank.bank).set(bank);
          invoiceBank.salaryType = this.addition;
          //res = self.$root.$firebaseRefs.invoice.push(invoiceBank);
          salaryData["invoiceIdBank"] = this.selectedBankInvoice;
          this.$root.$firebaseRefs.invoice
            .child(this.selectedBankInvoice)
            .set(invoiceBank);
          salaryData["amountFromBank"] = invoiceBank["totalAmount"];
          salaryData["bank"] = invoiceBank["bank"];
          self.additionAmount = null;
          self.selectedFirmFromAsset = null;
          self.staffRemark = null;
        }
      }

      this.$root.$firebaseRefs.salarys
        .child(this.selectedSalary[".key"])
        .set(salaryData);
      // close modal
      this.$emit("notify", "salary account edited", true);
      this.dialog = false;
      this.dialogEditInvoice = false;
      //this.reset(true);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/InvoiceManagement/table/salaryTable.vue